export default __webpack_public_path__ + "static/media/Img0026.2054eb05.png";